// import React from 'react';
// import { Link as RouterLink, useNavigate } from 'react-router-dom';
// import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
// import logo from './Averdex_logo.png';
// import { colors } from './theme';
// import { useAuth } from './App';

// function getEmailFromToken(token) {
//   if (!token) return null;
//   try {
//     const payload = JSON.parse(atob(token.split('.')[1]));
//     return payload.sub || payload.email || null;
//   } catch (e) {
//     return null;
//   }
// }

// export default function NavBar({ isAuthenticated, authToken, onSignIn, onSignOut }) {
//   const navigate = useNavigate();
//   const { auth } = useAuth();
//   const email = getEmailFromToken(authToken);
//   const isApplicant = auth?.user?.is_applicant === true;

//   return (
//     <AppBar
//       position="fixed"
//       elevation={0}
//       sx={{
//         backgroundColor: 'rgba(255,255,255,0.92)',
//         backdropFilter: 'blur(12px)',
//         borderBottom: '1px solid rgba(148, 163, 184, 0.4)',
//       }}
//     >
//       <Toolbar
//         sx={{
//           width: '100%',
//           px: { xs: 2, sm: 3, md: 6 },
//           minHeight: 64,
//         }}
//       >
//         <Box
//           sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
//           onClick={() => navigate('/')}
//         >
//           <Box
//             component="img"
//             src={logo}
//             alt="Averdex Logo"
//             sx={{
//               width: 40,
//               height: 40,
//               mr: 1.5,
//               borderRadius: 1.5,
//               objectFit: 'contain',
//             }}
//           />
//           <Typography
//             variant="h6"
//             sx={{
//               color: colors.purple,
//               fontWeight: 700,
//               letterSpacing: 0.8,
//               fontSize: { xs: '1rem', sm: '1.1rem' },
//             }}
//           >
//             Averdex Careers
//           </Typography>
//         </Box>

//         {/* Spacer */}
//         <Box sx={{ flexGrow: 1 }} />

//         {/* Primary nav links + admin info */}
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: { xs: 1, sm: 1.5 },
//           }}
//         >
//           <Button
//             onClick={() => navigate('/')}
//             sx={{
//               textTransform: 'none',
//               fontWeight: 500,
//               fontSize: 14,
//               color: 'text.primary',
//               px: 1.5,
//               '&:hover': {
//                 backgroundColor: 'rgba(148,163,184,0.12)',
//               },
//             }}
//           >
//             Home
//           </Button>
//           <Button
//             component={RouterLink}
//             to="/jobs"
//             sx={{
//               textTransform: 'none',
//               fontWeight: 500,
//               fontSize: 14,
//               color: 'text.primary',
//               px: 1.5,
//               '&:hover': {
//                 backgroundColor: 'rgba(148,163,184,0.12)',
//               },
//             }}
//           >
//             Jobs
//           </Button>

//           {isAuthenticated && !isApplicant && (
//             <>
//               <Button
//                 variant="outlined"
//                 color="secondary"
//                 onClick={() => navigate('/admin')}
//                 sx={{
//                   textTransform: 'none',
//                   fontWeight: 600,
//                   fontSize: 13,
//                   borderRadius: 999,
//                   px: 2,
//                   py: 0.5,
//                   borderWidth: 1,
//                   '&:hover': {
//                     borderWidth: 1,
//                   },
//                 }}
//               >
//                 Admin Dashboard
//               </Button>
//               <Typography
//                 sx={{
//                   display: { xs: 'none', sm: 'block' },
//                   color: colors.purple,
//                   fontSize: 13,
//                   fontWeight: 500,
//                 }}
//               >
//                 {email ? `Logged in as ${email}` : 'Logged in'}
//               </Typography>
//             </>
//           )}

//           {/* Auth button */}
//           {isAuthenticated ? (
//             <Button
//               color="primary"
//               variant="contained"
//               onClick={onSignOut}
//               sx={{
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 fontSize: 13,
//                 borderRadius: 999,
//                 px: 2.5,
//                 boxShadow: '0 6px 18px rgba(79, 70, 229, 0.35)',
//               }}
//             >
//               Sign Out
//             </Button>
//           ) : (
//             <Button
//               color="primary"
//               variant="contained"
//               onClick={() => navigate('/signin')}
//               sx={{
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 fontSize: 13,
//                 borderRadius: 999,
//                 px: 2.5,
//                 boxShadow: '0 6px 18px rgba(79, 70, 229, 0.35)',
//               }}
//             >
//               Sign In / Sign Up
//             </Button>
//           )}
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// }

import React, { useMemo, useState } from "react";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Drawer,
  IconButton,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import logo from "./Averdex_logo.png";
import { useAuth } from "./App";

function getEmailFromToken(token) {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub || payload.email || null;
  } catch (e) {
    return null;
  }
}

function NavLinkButton({ active, children, onClick, component, to, colorSet }) {
  return (
    <Button
      component={component}
      to={to}
      onClick={onClick}
      sx={{
        minWidth: 0,
        px: { xs: 1.1, sm: 1.5 },
        py: 0.9,
        borderRadius: "10px",
        textTransform: "none",
        fontWeight: active ? 700 : 600,
        fontSize: 14,
        color: active ? colorSet.accent : colorSet.mid,
        background: active ? alpha(colorSet.accent, colorSet.dark ? 0.14 : 0.08) : "transparent",
        transition: "all .2s ease",
        "&:hover": {
          background: active
            ? alpha(colorSet.accent, colorSet.dark ? 0.18 : 0.12)
            : alpha(colorSet.text, colorSet.dark ? 0.06 : 0.04),
          color: active ? colorSet.accent : colorSet.text,
        },
      }}
    >
      {children}
    </Button>
  );
}

function ThemeToggleButton({ dark, onToggleTheme, colors, mobile = false }) {
  if (mobile) {
    return (
      <IconButton
        onClick={onToggleTheme}
        aria-label={`Switch to ${dark ? "light" : "dark"} theme`}
        sx={{
          width: 42,
          height: 42,
          borderRadius: "12px",
          border: `1px solid ${colors.border}`,
          background: dark ? "rgba(255,255,255,0.03)" : "rgba(15,15,26,0.02)",
          color: colors.text,
          "&:hover": {
            background: dark ? "rgba(255,255,255,0.06)" : "rgba(15,15,26,0.05)",
          },
        }}
      >
        <Box component="span" sx={{ fontSize: 18, lineHeight: 1 }}>
          {dark ? "☀" : "☾"}
        </Box>
      </IconButton>
    );
  }

  return (
    <Button
      onClick={onToggleTheme}
      aria-label={`Switch to ${dark ? "light" : "dark"} theme`}
      sx={{
        minWidth: 0,
        borderRadius: "12px",
        px: 1.25,
        py: 0.75,
        textTransform: "none",
        border: `1px solid ${colors.border}`,
        background: dark ? "rgba(255,255,255,0.03)" : "rgba(15,15,26,0.02)",
        color: colors.text,
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        "&:hover": {
          background: dark ? "rgba(255,255,255,0.06)" : "rgba(15,15,26,0.05)",
        },
      }}
    >
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "9px",
          display: "grid",
          placeItems: "center",
          background: alpha(colors.accent, 0.12),
          color: colors.accent,
          fontSize: 15,
          lineHeight: 1,
        }}
      >
        {dark ? "☀" : "☾"}
      </Box>

      <Typography
        sx={{
          display: { xs: "none", lg: "block" },
          fontSize: 13,
          fontWeight: 700,
          color: colors.mid,
        }}
      >
        {dark ? "Light mode" : "Dark mode"}
      </Typography>
    </Button>
  );
}

export default function NavBar({
  isAuthenticated,
  authToken,
  onSignIn,
  onSignOut,
  onToggleTheme,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { auth } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const email = getEmailFromToken(authToken);
  const isApplicant = auth?.user?.is_applicant === true;
  const dark = theme.palette.mode === "dark";

  const colors = useMemo(
    () => ({
      dark,
      accent: dark ? "#fb923c" : "#f97316",
      pageBg: dark ? "#07080f" : "#ffffff",
      navBg: dark ? "rgba(7,8,15,0.72)" : "rgba(255,255,255,0.78)",
      text: dark ? "#e8f0fe" : "#0f0f1a",
      mid: dark ? "#94a3b8" : "#4b4b6a",
      muted: dark ? "#4b6080" : "#9898b8",
      border: dark ? "rgba(99, 179, 237, 0.12)" : "rgba(212, 212, 228, 0.8)",
      borderStrong: dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4",
    }),
    [dark]
  );

  const isHome = location.pathname === "/";
  const isJobs = location.pathname.startsWith("/jobs");
  const isAdmin = location.pathname.startsWith("/admin");
  const isAuthPage =
    location.pathname.startsWith("/signin") ||
    location.pathname.startsWith("/signup");

  const handleToggleTheme = () => {
    if (typeof onToggleTheme === "function") {
      onToggleTheme();
    }
  };

  const goTo = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const drawerButtonSx = {
    justifyContent: "flex-start",
    textTransform: "none",
    borderRadius: "12px",
    px: 1.5,
    py: 1.15,
    fontWeight: 600,
    fontSize: 14,
    color: colors.text,
    "&:hover": {
      background: alpha(colors.text, dark ? 0.06 : 0.04),
    },
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          background: colors.navBg,
          backdropFilter: "blur(16px)",
          borderBottom: `1px solid ${colors.border}`,
          boxShadow: dark
            ? "0 12px 40px rgba(0,0,0,0.25)"
            : "0 10px 32px rgba(15,15,26,0.05)",
          color: colors.text,
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 72, md: 78 },
            px: { xs: 2, sm: 3, md: 5 },
            gap: 2,
          }}
        >
          <Box
            onClick={() => navigate("/")}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.4,
              cursor: "pointer",
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: "14px",
                border: `1px solid ${alpha(colors.accent, 0.22)}`,
                background: dark
                  ? `linear-gradient(135deg, ${alpha(colors.accent, 0.16)}, rgba(13,18,32,0.88))`
                  : `linear-gradient(135deg, ${alpha(colors.accent, 0.10)}, rgba(255,255,255,0.96))`,
                display: "grid",
                placeItems: "center",
                boxShadow: dark
                  ? "0 10px 24px rgba(0,0,0,0.22)"
                  : "0 10px 24px rgba(15,15,26,0.06)",
                flexShrink: 0,
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="AjiraHQ"
                sx={{
                  width: 26,
                  height: 26,
                  objectFit: "contain",
                }}
              />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontWeight: 800,
                  letterSpacing: "-0.02em",
                  lineHeight: 1.05,
                  fontSize: { xs: "1rem", sm: "1.05rem" },
                  color: colors.text,
                  whiteSpace: "nowrap",
                }}
              >
                Averdex
              </Typography>

              <Typography
                sx={{
                  display: { xs: "none", sm: "block" },
                  mt: 0.35,
                  fontSize: "10.5px",
                  lineHeight: 1,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  fontWeight: 500,
                  color: colors.accent,
                  fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                }}
              >
                Recruitment / ATS
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 0.5,
              p: 0.5,
              borderRadius: "14px",
              border: `1px solid ${colors.border}`,
              background: dark ? "rgba(255,255,255,0.02)" : "rgba(15,15,26,0.02)",
            }}
          >
            <NavLinkButton
              active={isHome}
              onClick={() => navigate("/")}
              colorSet={colors}
            >
              Home
            </NavLinkButton>

            <NavLinkButton
              active={isJobs}
              component={RouterLink}
              to="/jobs"
              colorSet={colors}
            >
              Jobs
            </NavLinkButton>

            {isAuthenticated && !isApplicant && (
              <NavLinkButton
                active={isAdmin}
                onClick={() => navigate("/admin")}
                colorSet={colors}
              >
                Admin
              </NavLinkButton>
            )}
          </Box>

          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <ThemeToggleButton
              dark={dark}
              onToggleTheme={handleToggleTheme}
              colors={colors}
            />
          </Box>

          {isAuthenticated && (
            <Box
              sx={{
                display: { xs: "none", lg: "flex" },
                alignItems: "center",
                px: 1.5,
                py: 1,
                borderRadius: "12px",
                border: `1px solid ${colors.border}`,
                background: dark ? "rgba(255,255,255,0.02)" : "rgba(15,15,26,0.02)",
                maxWidth: 260,
              }}
            >
              <Typography
                sx={{
                  fontSize: 12.5,
                  color: colors.mid,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                }}
                title={email || "Logged in"}
              >
                {email ? email : "Logged in"}
              </Typography>
            </Box>
          )}

          {isAuthenticated ? (
            <Button
              variant="contained"
              onClick={onSignOut}
              sx={{
                display: { xs: "none", sm: "inline-flex" },
                textTransform: "none",
                fontWeight: 700,
                fontSize: 13.5,
                borderRadius: "12px",
                px: { sm: 2.2, md: 2.4 },
                py: 1.1,
                background: colors.accent,
                color: "#fff",
                boxShadow: `0 14px 34px ${alpha(colors.accent, 0.26)}`,
                "&:hover": {
                  background: colors.accent,
                  filter: "brightness(1.08)",
                  transform: "translateY(-1px)",
                },
              }}
            >
              Sign Out
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={() => navigate("/signin")}
              sx={{
                display: { xs: "none", sm: "inline-flex" },
                textTransform: "none",
                fontWeight: 700,
                fontSize: 13.5,
                borderRadius: "12px",
                px: { sm: 2.2, md: 2.4 },
                py: 1.1,
                background: colors.accent,
                color: "#fff",
                boxShadow: `0 14px 34px ${alpha(colors.accent, 0.26)}`,
                "&:hover": {
                  background: colors.accent,
                  filter: "brightness(1.08)",
                  transform: "translateY(-1px)",
                },
              }}
            >
              {isAuthPage ? "Continue" : "Sign In"}
            </Button>
          )}

          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              alignItems: "center",
              gap: 1,
            }}
          >
            <ThemeToggleButton
              dark={dark}
              onToggleTheme={handleToggleTheme}
              colors={colors}
              mobile
            />

            <IconButton
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
              sx={{
                width: 42,
                height: 42,
                borderRadius: "12px",
                border: `1px solid ${colors.border}`,
                background: dark ? "rgba(255,255,255,0.03)" : "rgba(15,15,26,0.02)",
                color: colors.text,
                "&:hover": {
                  background: dark ? "rgba(255,255,255,0.06)" : "rgba(15,15,26,0.05)",
                },
              }}
            >
              <Box component="span" sx={{ fontSize: 20, lineHeight: 1 }}>
                ☰
              </Box>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            width: "min(320px, 86vw)",
            background: dark ? "#0d1220" : "#ffffff",
            color: colors.text,
            borderLeft: `1px solid ${colors.border}`,
            p: 2,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "1rem",
              color: colors.text,
            }}
          >
            Menu
          </Typography>

          <IconButton
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
            sx={{
              width: 38,
              height: 38,
              borderRadius: "10px",
              color: colors.text,
            }}
          >
            <Box component="span" sx={{ fontSize: 18, lineHeight: 1 }}>
              ✕
            </Box>
          </IconButton>
        </Box>

        <Divider sx={{ borderColor: colors.border, mb: 1.5 }} />

        <Box sx={{ display: "grid", gap: 0.75 }}>
          <Button onClick={() => goTo("/")} sx={drawerButtonSx}>
            Home
          </Button>

          <Button onClick={() => goTo("/jobs")} sx={drawerButtonSx}>
            Jobs
          </Button>

          {isAuthenticated && !isApplicant && (
            <Button onClick={() => goTo("/admin")} sx={drawerButtonSx}>
              Admin Dashboard
            </Button>
          )}
        </Box>

        {isAuthenticated && (
          <>
            <Divider sx={{ borderColor: colors.border, my: 1.75 }} />
            <Box
              sx={{
                px: 1.5,
                py: 1.2,
                borderRadius: "12px",
                border: `1px solid ${colors.border}`,
                background: dark ? "rgba(255,255,255,0.02)" : "rgba(15,15,26,0.02)",
              }}
            >
              <Typography
                sx={{
                  fontSize: 12.5,
                  color: colors.mid,
                  wordBreak: "break-word",
                  fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                }}
              >
                {email ? email : "Logged in"}
              </Typography>
            </Box>
          </>
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Divider sx={{ borderColor: colors.border, my: 1.75 }} />

        {isAuthenticated ? (
          <Button
            variant="contained"
            onClick={() => {
              setMobileOpen(false);
              onSignOut?.();
            }}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              borderRadius: "12px",
              py: 1.2,
              background: colors.accent,
              color: "#fff",
              boxShadow: `0 14px 34px ${alpha(colors.accent, 0.26)}`,
              "&:hover": {
                background: colors.accent,
                filter: "brightness(1.08)",
              },
            }}
          >
            Sign Out
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={() => goTo("/signin")}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              borderRadius: "12px",
              py: 1.2,
              background: colors.accent,
              color: "#fff",
              boxShadow: `0 14px 34px ${alpha(colors.accent, 0.26)}`,
              "&:hover": {
                background: colors.accent,
                filter: "brightness(1.08)",
              },
            }}
          >
            {isAuthPage ? "Continue" : "Sign In"}
          </Button>
        )}
      </Drawer>
    </>
  );
}